'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _d2 = require('d3');

var d3 = _interopRequireWildcard(_d2);

var _reactMeasure = require('react-measure');

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var posteriorProbabilityScale = d3.scaleLinear().domain([0, 1]).range(['cyan', 'darkblue']);

var Regional = function (_React$Component) {
  _inherits(Regional, _React$Component);

  function Regional(props) {
    _classCallCheck(this, Regional);

    var _this = _possibleConstructorReturn(this, (Regional.__proto__ || Object.getPrototypeOf(Regional)).call(this, props));

    _this.svgRef = _react2.default.createRef();
    _this.x = d3.scaleLinear();
    _this.y = d3.scaleLinear();
    _this.voronoi = d3.voronoi();
    return _this;
  }

  _createClass(Regional, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._render();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._render();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var measureRef = this.props.measureRef;

      var _dimensions2 = this._dimensions(),
          outerWidth = _dimensions2.outerWidth,
          outerHeight = _dimensions2.outerHeight;

      return _react2.default.createElement(
        'div',
        { ref: measureRef },
        _react2.default.createElement(
          'svg',
          {
            xmlns: 'http://www.w3.org/2000/svg',
            width: outerWidth,
            height: outerHeight,
            ref: function ref(node) {
              return _this2.svgRef = node;
            }
          },
          _react2.default.createElement('g', {
            transform: 'translate(' + _theme2.default.margin.left + ',' + _theme2.default.margin.regionalTop + ')'
          })
        )
      );
    }
  }, {
    key: '_dimensions',
    value: function _dimensions() {
      var contentRect = this.props.contentRect;
      var outerWidth = contentRect.bounds.width;

      var outerHeight = 200;
      return { outerWidth: outerWidth, outerHeight: outerHeight };
    }
  }, {
    key: '_render',
    value: function _render() {
      var x = this.x,
          y = this.y,
          voronoi = this.voronoi;
      var _props = this.props,
          data = _props.data,
          title = _props.title,
          start = _props.start,
          end = _props.end;

      var _dimensions3 = this._dimensions(),
          outerWidth = _dimensions3.outerWidth,
          outerHeight = _dimensions3.outerHeight;

      if (!outerWidth || !outerHeight) {
        return;
      }

      var width = outerWidth - _theme2.default.margin.right - _theme2.default.margin.left;
      var height = outerHeight - _theme2.default.margin.regionalTop - _theme2.default.margin.regionalBottom;

      var svg = d3.select(this.svgRef);
      var chart = svg.select('g');

      var significance = -Math.log10(5e-8);

      var _d3$extent = d3.extent(data, function (d) {
        return -Math.log10(d.pval);
      }),
          _d3$extent2 = _slicedToArray(_d3$extent, 2),
          minLogPval = _d3$extent2[0],
          maxLogPval = _d3$extent2[1];

      x.domain([start, end]).range([0, width]);
      y.domain([Math.min(significance, minLogPval), Math.max(significance, maxLogPval)]).range([height, 0]);

      // const polygons = voronoi
      //   .x(d => x(d.studyId))
      //   .y(d => y(-Math.log10(d.pval)))
      //   .extent([[-1, -1], [width + 1, height + 1]])
      //   .polygons(assocs);

      // const traitCategoryRanges = getTraitCategoryRanges(assocs, x);
      // const traitPositions = traitCategoryRanges.map(
      //   range => (range.start + range.end) / 2
      // );
      // const traitCategories = traitCategoryRanges.map(
      //   category => category.traitCategory
      // );
      // categoryScale.domain(traitCategories).range(traitPositions);
      // colourScale.domain(traitCategories).range(d3.schemeCategory10);

      var xAxis = d3.axisBottom(x);
      var yAxis = d3.axisLeft(y);

      // this._renderLegend(svg, outerWidth);
      this._renderLogPValueAxis(chart, yAxis);
      this._renderPositionAxis(chart, height, xAxis);
      this._renderSignificanceLine(chart, y, width, significance);
      this._renderDataPoints(chart, data);
      this._renderLabel(chart, title);
      // this._renderTraitLabels(chart, polygons, x, y, significance);
      // this._renderVoronoi(chart, polygons);
    }
  }, {
    key: '_renderLogPValueAxis',
    value: function _renderLogPValueAxis(chart, yAxis) {
      var g = chart.select('.axis.axis--minus-log-pvalue');
      if (g.empty()) {
        g = chart.append('g').classed('axis axis--minus-log-pvalue', true);
      }
      g.call(yAxis);
      g.selectAll('.tick text').attr('fill', _theme2.default.axis.color);
      g.selectAll('.domain, .tick line').attr('stroke', _theme2.default.axis.color);

      var label = g.select('.axis-label.axis-label--minus-log-pvalue');

      if (label.empty()) {
        label = g.append('text').attr('class', 'axis-label axis-label--minus-log-pvalue').attr('transform', 'rotate(-90)').attr('font-size', 12).attr('dy', -40).attr('text-anchor', 'end').attr('fill', _theme2.default.axis.color).text('-log₁₀(p-value)');
      }
    }
  }, {
    key: '_renderPositionAxis',
    value: function _renderPositionAxis(chart, height, xAxis) {
      var g = chart.select('.axis.axis--studies');
      if (g.empty()) {
        g = chart.append('g').classed('axis axis--studies', true);
      }
      g.attr('transform', 'translate(0,' + height + ')').call(xAxis).selectAll('text')
      // .attr('transform', 'rotate(45)')
      // .attr('x', 0)
      // .attr('y', 0)
      // .attr('dx', '.4em')
      // .attr('dy', '1.5em')
      .attr('fill', _theme2.default.axis.color);
      // .style('text-anchor', 'start');
      g.selectAll('.domain, .tick line').attr('stroke', _theme2.default.axis.color);
    }
  }, {
    key: '_renderSignificanceLine',
    value: function _renderSignificanceLine(chart, y, width, significance) {
      var significanceLine = chart.select('.significance');

      if (significanceLine.empty()) {
        significanceLine = chart.append('line').classed('significance', true);
      }

      significanceLine.attr('x1', 0).attr('y1', y(significance)).attr('x2', width).attr('y2', y(significance)).attr('stroke', _theme2.default.secondary);
    }
  }, {
    key: '_renderDataPoints',
    value: function _renderDataPoints(chart, data) {
      var x = this.x,
          y = this.y;


      var dataPoints = chart.selectAll('circle.point').data(data, function (d) {
        return d.id;
      });

      dataPoints.enter().append('circle').attr('class', 'point').attr('stroke', _theme2.default.point.color).attr('r', 3).merge(dataPoints).attr('cx', function (d) {
        return x(d.position);
      }).attr('cy', function (d) {
        return y(-Math.log10(d.pval));
      }).attr('fill', function (d) {
        return d.is99CredibleSet ? posteriorProbabilityScale(d.posteriorProbability) : 'white';
      });

      dataPoints.exit().remove();
    }
  }, {
    key: '_renderLabel',
    value: function _renderLabel(chart, title) {
      var g = chart.select('.title');
      if (g.empty()) {
        g = chart.append('g').classed('title', true);
      }

      var label = g.select('text');

      if (label.empty()) {
        label = g.append('text').attr('font-size', 14).attr('font-weight', 'bold').attr('dy', -10).attr('fill', _theme2.default.axis.color).text(title);
      }
    }
  }]);

  return Regional;
}(_react2.default.Component);

exports.default = (0, _reactMeasure.withContentRect)('bounds')(Regional);